var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// ./~/element-ui/~/async-validator/~/babel-runtime/~/core-js/library/modules/_html.js
// module id = Rjo6
// module chunks = 0